export const free_spin_page = {
	FREE_SPIN_HEADER: {
		value: 'SURPRISE!',
		config: {
			fontFamily: 'Japanese',
			fontSize: 50,
			letterSpacing: 5,
			fill: ['#EF9904', '#dd741d']
		}
	},
	FREE_SPIN_TITLE: {
		value: 'YOU ARE GIFTED WITH',
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},

	FREE_SPIN_TIME_TEXT: {
		value: 'Valid Until',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22,
			align: 'center'
		}
	},
	FREE_SPIN_TIME: {
		value: '22.11.2024',
		config: {
			fill: '#DEE0EF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22,
			align: 'center'
		}
	},
	FREE_SPIN_PRIZE: {
		value: '8 FREE SPINS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 70,
			letterSpacing: 5,
			fill: ['#EF9904', '#dd741d']
		}
	},

	FREE_SPIN_INFO: {
		value:
			'*IN CASE OF CHOOSING “PLAY LATER”, THE FREE SPINS WILL BE AVAILABLE AFTER RELOADING THE GAME',
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20,
			align: 'center',
			wordWrap: true,
			wordWrapWidth: 550
		}
	},
	FREE_SPIN_PLAY_NOW: {
		value: 'PLAY NOW',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	},
	FREE_SPIN_PLAY_LATER: {
		value: 'PLAY LATER',
		config: {
			fill: '#E0C0C8',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	}
};
